interface IDateOnly {
  year: number;
  month: number;
  day: number;
}

function dateOnlyParse(input: string | null | undefined): IDateOnly | null {
  if (input == null) {
    return null;
  }

  const parts = input.split('-');

  if (parts.length !== 3) {
    return null;
  }

  const day = Number(parts[2]);
  const month = Number(parts[1]);
  const year = Number(parts[0]);

  const date = new Date(year, month - 1, day);
  const dateYear = date.getFullYear();
  const dateMonthIndex = date.getMonth();
  const dateDay = date.getDate();

  if (dateYear !== year) {
    return null;
  } else if (dateMonthIndex !== month - 1) {
    return null;
  } else if (dateDay !== day) {
    return null;
  }

  return {
    year: dateYear,
    month: dateMonthIndex + 1,
    day: dateDay,
  };
}

export default dateOnlyParse;
